module.exports = __webpack_public_path__ + "static/media/13.b01a1b9c.jpg";